
import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import CommentIcon from "@mui/icons-material/Comment";
import FeedbackIcon from "@mui/icons-material/Feedback";
import CallIcon from "@mui/icons-material/Call";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CancelIcon from "@mui/icons-material/Cancel";
import { CheckCircleRounded, Flag } from "@mui/icons-material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CircleIcon from "@mui/icons-material/Circle";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import FlagIcon from "@mui/icons-material/Flag";
/*
 * A component that renders Material-UI icons based on the provided name.
 * 
 * @component
 * @param {Object} props - The component props
 * @param {string} props.name - The name of the icon to render. Valid values are:
 *   - "home" - Home icon
 *   - "timetable" - Clock icon
 *   - "attendance" - Assignment icon
 *   - "money" - Money icon
 *   - "staff" - Person icon
 *   - "settings" - Settings gear icon
 *   - "feedback" - Feedback icon
 *   - "comments" - Comment bubble icon
 *   - "bike" - Motorcycle icon
 *   - "call" - Phone icon
 *   - "student" - School icon
 *   - "delete" - Trash can icon
 *   - "add" - Plus icon
 *   - "edit" - Pencil icon
 *   - "menu" - Hamburger menu icon
 *   - "leftArrow" - Back arrow icon
 *   - "rightArrow" - Forward arrow icon
 *   - "leftChevron" - Left chevron icon
 *   - "rightChevron" - Right chevron icon
 *   - "upChevron" - Up chevron icon
 *   - "downChevron" - Down chevron icon
 *   - "close" - X close icon
 *   - "book" - Book icon
 *   - "cancel"/"x" - Cancel icon
 *   - "tick" - Checkmark circle icon
 *   - "circle" - Circle icon
 *   - "swap" - Horizontal swap arrows icon
 * @returns {React.ReactElement} The rendered icon component or a div with "Icon" text if name is not recognized
 */
export default function Icon({name}) {

    if(name === "home") return "🏠"
    if(name === "timetable") return "⌚"
    if(name === "attendance") return(<AssignmentIcon/>)
    if(name === "money") return(<AttachMoneyIcon/>)
    if(name === "staff") return(<PersonIcon/>)
    if(name === "settings") return(<SettingsIcon/>)
    if(name === "feedback") return(<FeedbackIcon/>)
    if(name === "comments") return(<CommentIcon/>)
    if(name === "bike") return(<TwoWheelerIcon/>)
    if(name === "call") return (<CallIcon />) 
    if(name === "student") return (<SchoolIcon />)
    if(name === "delete") return <DeleteIcon />;
    if(name === "add" || name==="plus") return <AddIcon />;
    if(name === "edit") return <EditIcon />;
    if(name === "menu") return <MenuIcon />;
    if(name === "leftArrow") return <ArrowBackIcon />;
    if (name === "rightArrow") return <ArrowForwardIcon />;
    if (name === "leftChevron") return <ArrowLeftIcon/>;
    if (name === "rightChevron") return <ArrowRightIcon />;
    if (name === "upChevron") return <KeyboardArrowUpIcon />;
    if (name === "downChevron") return <KeyboardArrowDownIcon />;
    if (name === "close") return <CloseIcon />;
    if (name === "book") return <AutoStoriesIcon />
    if (name === "cancel" || name === "x") return <CancelIcon />
    if (name === "tick") return <CheckCircleRounded />;
    if (name === "circle") return <CircleIcon />;
    if (name === "swap") return <SwapHorizIcon />;
    if (name === "flag") return <Flag />;
    if(name==="person") return <>👤</>

return(<div>Icon</div>)
}